import { render } from "./StockHome.vue?vue&type=template&id=4056b982&ts=true"
import script from "./StockHome.vue?vue&type=script&lang=ts"
export * from "./StockHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__